/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IAllSonElements = Application.Models.IAllSonElements;
    import SimpleSonElement = Application.Models.SimpleSonElement;

    interface IGridMonitor {
        tx: Models.IBlock;
        rx: Models.IBlock;
        type?: 'Video' | 'SwitchPort';
        // switch?: Models.ISwitch;
        dataPortSource?: Models.ISimpleSonElement,
        dataPortSink?: Models.ISimpleSonElement;
    }

    interface IExtendedBlock extends Models.Block {
        icon?: string;
    }


    export interface IGridStreamSelectionModalScope extends ng.IScope {
        modalClose: () => void;
        modalSave: () => void;
        txs:  IExtendedBlock[];
        rxs: IExtendedBlock[];
        matchedTxs:  Models.IBlock[];
        matchedRxs: Models.IBlock[];
        matchedHostnameSources: Models.ISimpleSonElement[];
        matchedHostnameSinks: Models.ISimpleSonElement[];
        //switches: Models.ISwitch[];
        selected: IGridMonitor;
        dataPortMode: boolean;
        loading: boolean;
        search: {
            tx: string,
            rx: string
        };
        filterTx: () => void;
        filterRx: () => void;
        onChangeType: () => void;
        onChangeTx: (value: Models.IBlock) => void;
        onChangeRx: (value: Models.IBlock) => void;
        onChangeDataSource: (value: Models.ISimpleSonElement) => Promise<void>;
        onChangeDataSink: (value: Models.ISimpleSonElement) => Promise<void>;
        shouldDisableButton: (id: number | string) => void;
        disableButton: boolean;
    }

    export class GridStreamSelectionModalController {
        public static templateUrl: string = "decorators/modals/grid-stream-selection-modal.html";
        public static id: string = "#id-grid-stream-selection-modal";
        public static $name: string = "gridStreamSelectionModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'blockService', 'sonAdapterService', '$q', 'currentMonitor'];

        private static PARSLEY_CHECK_VALIDATE_AT_LEAST: string = 'atleast';
        private static OUT_DATA_PORT_MODEL: string = 'CM5000';
        private static IN_DATA_PORT_MODEL: string = 'DR5000';

        /**
         * Constructor
         */
        constructor($scope: IGridStreamSelectionModalScope,
                    close: (parameters: {tx: number, rx: number, currentMonitor: Models.IGridMonitor, type: 'Video'|'SwitchPort'}) => void,
                    private $timeout: ng.ITimeoutService,
                    private blockService: Services.BlockService,
                    private sonService: Services.SonAdapterService,
                    private qService: ng.IQService,
                    currentMonitor: Models.IGridMonitor) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.addParsleyValidateAtLeastOne();
            $scope.search = {tx: '', rx: ''};
            $scope.disableButton = true;

            $scope.loading = true;
            $scope.dataPortMode = (typeof currentMonitor !== 'undefined' && currentMonitor.type === 'SwitchPort');

            $scope.selected = {
                tx: undefined,
                rx: undefined,
                type: $scope.dataPortMode ? 'SwitchPort' : 'Video',
                // switch: ($scope.switches !== undefined && $scope.switches.length > 0) ? $scope.switches[0] : undefined,
                dataPortSource: SimpleSonElement.Empty("sources"),
                dataPortSink: SimpleSonElement.Empty("destinations")
            };


            if (!$scope.dataPortMode) {
                this.initVideoMode($scope, currentMonitor);
            } else {
                this.initDataMode($scope, currentMonitor);
            }


            $scope.modalClose = (): void => {
                close(undefined);
            };

            $scope.modalSave = (): void => {
                close({
                    rx: this.getRxId($scope.selected, $scope.dataPortMode),
                    tx: this.getTxId($scope.selected, $scope.dataPortMode),
                    currentMonitor: currentMonitor,
                    type: $scope.dataPortMode ? 'SwitchPort' : 'Video',
                });
            };

            $scope.onChangeTx = (value: Models.IBlock): void => {
                $scope.selected.tx = angular.copy(value);
                $scope.shouldDisableButton(value.id);
            };

            $scope.onChangeRx = (value: Models.IBlock): void => {
                $scope.selected.rx = angular.copy(value);
                $scope.shouldDisableButton(value.id);
            };

            $scope.onChangeDataSource = async (value: Models.ISimpleSonElement): Promise<void> => {
                if (value.meta.dns !== "")
                    $scope.shouldDisableButton(value.meta.dns);
                else
                    $scope.shouldDisableButton($scope.selected.dataPortSink.meta.dns);

            };

            $scope.onChangeDataSink = async (value: Models.ISimpleSonElement): Promise<void> => {
                if (value.meta.dns !== "")
                    $scope.shouldDisableButton(value.meta.dns);
                else
                    $scope.shouldDisableButton($scope.selected.dataPortSource.meta.dns);
            };

            $scope.onChangeType = (): void => {
                let id: number | string;
                $scope.loading = true;
                if ($scope.dataPortMode) {
                    this.initDataMode($scope, currentMonitor);
                } else {
                    this.initVideoMode($scope, currentMonitor);
                }
            };
            
            $scope.$on('$destroy', () => {
                window.Parsley.removeValidator(GridStreamSelectionModalController.PARSLEY_CHECK_VALIDATE_AT_LEAST);
            });

            $scope.shouldDisableButton = (id: number | string): void => {
                $scope.disableButton = id === undefined || id === null || id === "";
            }
        }

        private initDataMode($scope: IGridStreamSelectionModalScope, currentMonitor: Models.IGridMonitor) {
            this.sonService.getAllSonElements().then((allElements: IAllSonElements) => {
                $scope.matchedHostnameSources = allElements.sources;
                $scope.matchedHostnameSources.unshift(SimpleSonElement.Empty("sources"));
                $scope.matchedHostnameSinks = allElements.destinations;
                $scope.matchedHostnameSinks.unshift(SimpleSonElement.Empty("destinations"));
                let loadingSource: boolean, loadingSink: boolean = false;
                if (currentMonitor && currentMonitor.source) {
                    loadingSource = true;
                    this.sonService.getSourceByUid("" + currentMonitor.source).then((sourceElement: Models.ISimpleSonElement) => {
                        $scope.selected.dataPortSource = sourceElement;
                        loadingSource = false;
                        if (!loadingSink)
                            $scope.loading = false;
                    });
                }
                if (currentMonitor && currentMonitor.sink) {
                    loadingSink = true;
                    this.sonService.getDestinationByUid("" + currentMonitor.sink).then((sinkElement: Models.ISimpleSonElement) => {
                        $scope.selected.dataPortSink = sinkElement;
                        loadingSink = false;
                        if (!loadingSource)
                            $scope.loading = false;
                    });
                }
                $scope.loading = loadingSource || loadingSink;
            });
        }

        private initVideoMode($scope: IGridStreamSelectionModalScope, currentMonitor: Models.IGridMonitor) {
            this.qService.all([
                this.blockService.findSourceBlocksPromise(),
                this.blockService.findSinkBlocksPromise(),
            ]).then((res: [Models.IBlock[], Models.IBlock[]]) => {
                $scope.txs = res[0].map((blk: IExtendedBlock) => {
                    blk.icon = this.blockService.getNetworkNodeIcon(blk);
                    return blk;
                });
                $scope.rxs = res[1].map((blk: IExtendedBlock) => {
                    blk.icon = this.blockService.getNetworkNodeIcon(blk);
                    return blk;
                });

                $scope.txs.sort((a: Models.IBlock, b: Models.IBlock): number => {
                    if (typeof currentMonitor !== 'undefined' && currentMonitor.sourceName &&
                        a.name !== b.name && currentMonitor.type === 'Video') {
                        // put the current monitor name first and move blank one to last position
                        if (currentMonitor.sourceName === a.name || b.name === "") {
                            return -1;
                        } else if (b.name === currentMonitor.sourceName || a.name === "") {
                            return 1;
                        }
                    }

                    return a.name.localeCompare(b.name);
                });

                if ($scope.rxs !== undefined) {
                    $scope.rxs.sort((a: Models.IBlock, b: Models.IBlock): number => {
                        if (typeof currentMonitor !== 'undefined' && currentMonitor.sinkName &&
                            a.name !== b.name && currentMonitor.type === 'Video') {
                            // put the current monitor name first and move blank one to last position
                            if (currentMonitor.sinkName === a.name || b.name === "") {
                                return -1;
                            } else if (b.name === currentMonitor.sinkName || a.name === "") {
                                return 1;
                            }
                        }
                        return a.name.localeCompare(b.name);
                    });
                }
                $scope.loading = false;
                $scope.matchedTxs = $scope.txs;
                $scope.matchedRxs = $scope.rxs;
            });
        }

        private addParsleyValidateAtLeastOne(): void {
            window.Parsley
                .addValidator(GridStreamSelectionModalController.PARSLEY_CHECK_VALIDATE_AT_LEAST, {
                    validateString: (value: string, requirement?: string): boolean => {
                        window.Parsley.addMessage('en', GridStreamSelectionModalController.PARSLEY_CHECK_VALIDATE_AT_LEAST,
                            'Fill at least ' + requirement + ' input');
                        return this.validateAtLeast(Number(requirement));
                    },
                });

        }

        private validateAtLeast( count: number): boolean {
            let found: number = 0;
            $('*[data-parsley-atleast]').each((i: number, item: any) => { // tslint:disable-line
                // if its a custom directive check inside val.name
                let itemValue: any = $(item).prop("tagName").includes('EPIC') ? $(item).val().name : $(item).val(); // tslint:disable-line
                if (itemValue)
                    found++;
            });
            return found >= count;
        }

        private getRxId(selected: IGridMonitor, dataPortMode: boolean): number {
            return dataPortMode && selected.dataPortSink
                ? selected.dataPortSink.uid ? Number(selected.dataPortSink.uid) : undefined
                : selected.rx ? selected.rx.id : undefined;
        }

        private getTxId(selected: IGridMonitor, dataPortMode: boolean): number {
            return dataPortMode && selected.dataPortSource
                ? selected.dataPortSource.uid ? Number(selected.dataPortSource.uid) : undefined
                : selected.tx ? selected.tx.id : undefined;
        }
    }
}